/**
 * Paths that can resolve workspace context from the URL (or project fetch)
 * and must not be blocked by RequireWorkspace when activeWorkspaceId is unset.
 */

const UUID =
  "[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}";

const RE_SLUG_BOOTSTRAP = /^\/w\/[^/]+(?:\/home)?$/;
const RE_WORKSPACE_ID = new RegExp(`^/workspaces/(${UUID})(?:/|$)`, "i");
const RE_PROJECT = new RegExp(`^/projects/(${UUID})(?:/|$)`, "i");
const RE_WORK_PLAN = new RegExp(`^/work/projects/(${UUID})/plan$`, "i");

export function isWorkspaceUrlBootstrapPath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  return (
    RE_SLUG_BOOTSTRAP.test(p) ||
    RE_WORKSPACE_ID.test(p) ||
    RE_PROJECT.test(p) ||
    RE_WORK_PLAN.test(p)
  );
}

/** Extract workspace UUID from /workspaces/:workspaceId/... when present. */
export function workspaceIdFromPathname(pathname: string): string | null {
  const p = pathname.replace(/\/+$/, "") || "/";
  const m = p.match(RE_WORKSPACE_ID);
  return m?.[1] ?? null;
}
